export default "QuestBox opened in July 2016.";